export default "__VITE_ASSET__e73f5715__"